import React, { useState } from "react";
import { ROUTES } from "../constants/routes";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoginPassword from "./components/LoginPassword";
import RecoverPassword from "./auth-widget/forgot-password-widget/RecoverPassword";

export const StudentLoginPage = ({ toggleTAndC, togglePAndP }) => {
  const { t } = useTranslation();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const toggleShowForgotPassword = () => {
    setShowForgotPassword(!showForgotPassword);
  };
  const handleBackToLogin = () => {
    // Function to go back to login screen from RecoverPassword
    setShowForgotPassword(false);
  };

  return (
    <>
      <header className="frontheader__banner">
        <div className="white__layerbg"></div>
        <div className="banner__contentbox no_auth">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-7">
                <h1 className="banner__contentbox--title">
                  <span className="text--secondary--grad">{t("home_page.p1_heading")}</span>
                </h1>
                <p className="banner__contentbox--text mt-2 pt-1">{t("home_page.p1_content")}</p>{" "}
              </div>
              <div id="signup" className="col-md-12 col-lg-5 position-relative">
                {!showForgotPassword ? (
                  <div className="membership__card mx-auto ms-md-auto">
                    <div className="tab-content">
                      <h3 className="tab-heading">Student Login</h3>
                      <LoginPassword
                        toggleShowForgotPassword={toggleShowForgotPassword}
                        toggleTAndC={toggleTAndC}
                        togglePAndP={togglePAndP}
                      />
                    </div>
                  </div>
                ) : (
                  <RecoverPassword onBackToLogin={handleBackToLogin} />
                )}
              </div>
              <div className="col-12 create-ac-link-web">
                <p className="login--supporttext">
                  Don&apos;t have an Genius account?{" "}
                  <Link to={ROUTES.STUDENT_CREATE_ACCOUNT} className="gard--textflow">
                    Create Account
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
